var VALID_PROP_REG = /^[a-zA-Z$_][a-zA-Z0-9$_]*$/;
export function emitInlineAccessor(obj, prop) {
    if (prop && VALID_PROP_REG.test(prop)) {
        return "".concat(obj, ".").concat(prop);
    }
    return "".concat(obj, "[\"").concat(prop, "\"]");
}
